export default __webpack_public_path__ + "static/iPhone13-e83b58ef69474dc265a00b298226da8e.png";